import { render, staticRenderFns } from "./AudienceCard.vue?vue&type=template&id=8ba2f0f4&scoped=true&"
import script from "./AudienceCard.vue?vue&type=script&lang=ts&"
export * from "./AudienceCard.vue?vue&type=script&lang=ts&"
import style0 from "./AudienceCard.vue?vue&type=style&index=0&id=8ba2f0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba2f0f4",
  null
  
)

export default component.exports